module.exports = __webpack_public_path__ + "static/media/starship-freighter.5c1384ec.svg";